import { IErrorMessage } from '../components/errorMessage/errorMessage.type';

export enum ValidatorRule {
    JPFirstNameLengthRule = 'JPFirstNameLengthRule',
    EUFirstNameLengthRule = 'EUFirstNameLengthRule',

    JPLastNameLengthRule = 'JPLastNameLengthRule',
    EULastNameLengthRule = 'EULastNameLengthRule',

    KannaRule = 'KannaRule',
    KannaLengthRule = 'KannaLengthRule',

    JPNicknameLengthRule = 'JPNicknameLengthRule',
    EUNicknameLengthRule = 'EUNicknameLengthRule',

    CountryLengthRule = 'CountryLengthRule',

    EUEmailRule = 'EUEmailRule',
    JPEmailRule = 'JPEmailRule',
    EmailLengthRule = 'EmailLengthRule',
    JPEmailLength100thRule = 'JPEmailLength100thRule',

    EUNewPasswordLengthRangeRule = 'EUNewPasswordLengthRangeRule',
    EUPasswordIncludeCharRule = 'EUPasswordIncludeCharRule',
    JPNewPasswordCheckRule = 'JPNewPasswordCheckRule',

    JPUsernameRangeRule = 'JPUsernameRangeRule',
    EUUsernameRangeRule = 'EUUsernameRangeRule',

    LatinCharactersRule = 'LatinCharactersRule',
    SpaceRule = 'SpaceRule',
    PasswordSpaceRule = 'PasswordSpaceRule',

    EUCardNumberRangRule = 'EUCardNumberRangRule',
    JPCardNumberRangRule = 'JPCardNumberRangRule',

    JPCardHolderNameLengthRule = 'JPCardHolderNameLengthRule',
    EUCardHolderNameLength = 'EUCardHolderNameLengthRule',
    cardHolderNameContainsSpecialCharsRule = 'cardHolderNameContainsSpecialCharsRule',
    cardHolderNameContainsDigitsRule = 'cardHolderNameContainsDigitsRule',
    JPCardHolderNameContainsSpecialCharsRule = 'JPCardHolderNameContainsSpecialCharsRule',

    EUCompanyLengthRule = 'EUCompanyLengthRule',
    JPCompanyLengthRule = 'JPCompanyLengthRule',

    EUCityLengthRule = 'EUCityLengthRule',
    JPCityLengthRule = 'JPCityLengthRule',

    EUDobRule = 'EUDobRule',
    JPDobRule = 'JPDobRule',

    EUCJPCharsRule = 'EUCJPCharsRule',
    FullWidthSpaceRule = 'FullWidthSpaceRule',

    NoControlCharactersRule = 'NoControlCharactersRule',
}

export interface IValidateFunc {
    (value: string): boolean;
}

export interface IDateValidateFunc {
    (value: Date): boolean;
}

export interface IValidateError {
    value: string;
    rule: string;
    message: IErrorMessage;
}

export type ValidatorResult = IValidateError | null;
